module.exports = __webpack_public_path__ + "static/media/Pollo a la mostaza.2568b485.jpg";